<div class="component-container">
  <div class="d-flex justify-content-between align-items-center">
    <div class="title">Feature Flags</div>
    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-secondary" (click)="refreshFeatureFlags()" type="button" data-testid="feature-flags-refresh">
        <span class="fa fa-refresh"></span>
        Refresh
      </button>
      <button class="btn btn-secondary" (click)="restoreAllOverrides()" type="button" data-testid="feature-flags-remove-all-overrides">
        <span class="fa fa-xmark"></span>
        Remove All Overrides
      </button>
    </div>
  </div>
  <div class="feature-flags-grid">
    <div class="header text-center">Active</div>
    <div class="header text-center">Override</div>
    <div class="header">Description</div>
    <ng-container *ngFor="let flag of featureFlags; let i = index">
      <div class="checkbox-cell">
        <label [for]="'feature-flag-' + flag.id" class="hidden">Toggle {{ flag.description }}</label>
        <input
          type="checkbox"
          [checked]="flag.isActive"
          (change)="onToggleIsActive(flag)"
          id="feature-flag-{{flag.id}}"
          title="Toggle {{ flag.description }}"
          [attr.data-testid]="'feature-flags-flag-checkbox-' + i"/>
      </div>
      <div class="override-cell text-center">
        <span *ngIf="isOverridden(flag)" class="override-indicator" title="Temporarily overridden">Overridden</span>
      </div>
      <div class="description-cell">
        <div class="desc-main"><strong>{{ flag.description }}</strong></div>
        <div class="desc-helper">{{ flag.name }}</div>
      </div>
    </ng-container>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/developer/feature-flags/feature-flags.component.html